// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__RIafz","checkboxCol":"Table_checkboxCol__2g-76","emailCol":"Table_emailCol__1rlae","actionCol":"Table_actionCol__1VoO9"};